import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-input-filled:focus, .ant-input-filled:focus-within {
    outline: 0;
    border-color: var(--app-border);
    background-color: var(--app-surface);
  }

  .manage-user-search-wrap {
    background: var(--app-surface);
  }

  .manage-user-search-icon,
  .manage-user-action-icon,
  .manage-user-name-link {
    color: var(--app-text);
  }

  .manage-user-action-icon--disabled {
    color: var(--app-text-muted);
    opacity: 0.65;
  }

  .manage-user-search-input {
    color: var(--app-text) !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
  }

  .manage-user-table-header-row {
    color: var(--app-text) !important;
  }

  .manage-user-trial-edit-wrap {
    min-width: 240px;
  }

  .manage-user-trial-read-wrap {
    cursor: default;
  }

  .manage-user-trial-expired {
    color: #f45b68;
  }

  .manage-user-trial-edit-icon {
    color: #f45b68;
    cursor: pointer;
    font-size: 13px;
  }

  .manage-user-trial-save-btn {
    background: #f45b68 !important;
    border-color: #f45b68 !important;
  }

  .manage-user-delete-title,
  .manage-user-delete-name,
  .manage-user-form-label {
    color: var(--app-text) !important;
  }

  .manage-user-form-input {
    background: var(--app-surface-alt) !important;
    color: var(--app-text) !important;
    border-color: var(--app-border) !important;
  }
`;